import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { watch, Ref } from "vue";
import { FindOneProveedorAction } from "../../actions/proveedorActions";

export function useProveedorFindOne(id: Ref<string>) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["ProveedorFindOne", id],
    queryFn: () => FindOneProveedorAction(id.value),
    enabled: !!id.value, // evita ejecutar si id está vacío
    staleTime: 60 * 1000, // cache por 1 minuto
  });

  // Si cambia el ID, hacer prefetch del nuevo proveedor
  watch(id, (newId) => {
    if (newId) {
      queryClient.prefetchQuery({
        queryKey: ["ProveedorFindOne", newId],
        queryFn: () => FindOneProveedorAction(newId),
      });
    }
  });

  return {
    ...query, // => { data, isLoading, isError, error, refetch, ... }
  };
}
